module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.userInformation !== {}) ? _c('pl-dialog', {
    staticClass: "text-sm",
    attrs: {
      "title": "Nudge",
      "size": "confirm_size",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('closeDialog', false)
      }
    }
  }, [_c('div', {
    staticClass: "flex flex-col space-y-4 h-full px-6 py-5"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-message text-emerald-600"
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v("Send a Message to")]), _vm._v(" "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v(" " + _vm._s(_vm.userInformation.user.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "h-full flex-grow"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "w-full outline-none border border-solid border-gray-200 bg-gray-50 resize-none rounded px-5 py-3",
    attrs: {
      "rows": "6",
      "placeholder": "Nudge! Have something to say?"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2 justify-between"
  }, [_c('button', {
    staticClass: "w-full bg-gray-100 border border-solid border-gray-200 px-6 py-2 rounded-md",
    on: {
      "click": function($event) {
        return _vm.$emit('closeDialog', false)
      }
    }
  }, [_vm._v("\n        Cancel\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "w-full bg-green hover:bg-emerald-600 px-6 py-2 rounded-md text-white",
    on: {
      "click": _vm.sendNudge
    }
  }, [_vm._v("\n        Send Message\n      ")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-8d59a2f0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/Participants/SendNudge.vue
// module id = 1811
// module chunks = 61